module.exports = __webpack_public_path__ + "img/web_default.98129c74.png";